import { LitElement, html, css } from 'lit'
import { consume } from '@lit/context'
import { breakpointContext, isOutletNavigationOpenContext, isSubMenuOpenContext } from './context.ts'
import { customElement } from 'lit/decorators.js'
import { TW, type Breakpoint } from '../../shared'

const TwLitElement = TW(LitElement)

@customElement('button-ansprechpartner')
export class ButtonAnsprechpartner extends TwLitElement {

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    @consume({context: isSubMenuOpenContext, subscribe: true})
    private _isSubMenuOpen: boolean = false

    @consume({context: isOutletNavigationOpenContext, subscribe: true})
    private _isOutletNavigationOpen: boolean = false

    static styles = css`
        :host {
            display: block;
        }
        :host([hidden]) {
            display: none;
        }
    `

    private _isDisplayAsIcon() {
        return [ 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl' ].includes( this._breakpoint?.name ?? '' )
    }

    private _isShown() {
        return ! this._isOutletNavigationOpen && ! this._isSubMenuOpen
    }

    render() 
    {
        if ( ! this._isShown() ) {
            this.setAttribute( 'hidden', '' )
            return html``
        }

        this.removeAttribute( 'hidden' )

        return this._isDisplayAsIcon()
            ? html`<div class="wp-block-button is-bmw-icon is-bmw-icon-people-group-rg"><a href="/ansprechpartner" class="wp-element-button cursor-pointer w-[50px] h-[60px] leading-0 before:pr-0!" aria-label="Ansprechpartner"></a></div>`
            : html`<div class="wp-block-button is-bmw-icon is-bmw-icon-people-group-rg"><a href="/ansprechpartner" class="wp-element-button cursor-pointer w-[50px] h-[60px] m-0 p-0 font-medium" aria-label="Ansprechpartner">Ansprechpartner</a></div>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'button-ansprechpartner': ButtonAnsprechpartner
    }
}
